// components/ProtectedRoute.tsx
import { CSpinner } from '@coreui/react-pro';
import { JSX, ReactNode } from 'react';
import { Navigate } from 'react-router';

import { isExtCharts } from './helpers/helpers';
import { AuthenticatedUserProvider, useUnauthenticatedUserContext } from './hooks/contexts/useUserDataContext';
interface ProtectedRouteProps {
    children: ReactNode;
    redirectTo?: string;
}

export const ProtectedRoute = ({ children, redirectTo = "/login" }: ProtectedRouteProps): JSX.Element => {
    const { userData, loading } = useUnauthenticatedUserContext();

    if (loading) {
        return (
            <div className='d-flex vh-100 justify-content-center align-items-center'>
                <CSpinner color='primary' />
            </div>
        );
    }

    if (!userData && !isExtCharts) {
        console.warn('ProtectedRoute: No user data found, redirecting to login');
        return <Navigate to={redirectTo} replace />;
    }
    return (
        <AuthenticatedUserProvider>
            {children}
        </AuthenticatedUserProvider>
    );
};

// components/PublicRoute.tsx - Redirect authenticated users away from login
export const PublicRoute = ({ children }: { children: ReactNode }): JSX.Element => {
    const { userData } = useUnauthenticatedUserContext();
    if (userData) {
        return <Navigate to="/dashboard" replace />;
    }
    return <>{children}</>;
};